import { Prismic } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { GdprUpdateType } from '../../__generated__/globalTypes';
import { RequestGdprData } from '../components/gdpr-request/RequestGdprData/RequestGdprData';
import { UpdateGdprData } from '../components/gdpr-request/UpdateGdprData';

interface IProps {
  type: string;
  text: Prismic.RichText;
  header: Prismic.RichText;
  login_title: Prismic.RichText;
  login_description: Prismic.RichText;
  login_image: Prismic.Image;
}

const typeToGdprUpdateType = (type: string) => {
  switch (type) {
    case 'Leiðrétting':
      return GdprUpdateType.Correction;
    case 'Eyðing':
      return GdprUpdateType.Deletion;
    case 'Takmörkun':
      return GdprUpdateType.Limitation;
    default:
      return undefined;
  }
};

export const GdprRequestContainer = ({
  type,
  text,
  header,
  login_title,
  login_description,
  login_image,
}: IProps) => {
  return (
    <Segment>
      {type === 'Aðgangur' && (
        <RequestGdprData
          title={Prismic.text(header) ?? ''}
          description={Prismic.text(text) ?? ''}
          login_title={Prismic.text(login_title) ?? ''}
          login_description={Prismic.text(login_description) ?? ''}
          login_image={login_image}
        />
      )}
      {typeToGdprUpdateType(type) && (
        <UpdateGdprData
          type={typeToGdprUpdateType(type) ?? GdprUpdateType.Correction}
          title={Prismic.text(header) ?? ''}
          descriptionText={Prismic.text(text) ?? ''}
          login_title={Prismic.text(login_title) ?? ''}
          login_description={Prismic.text(login_description) ?? ''}
          login_image={login_image}
        />
      )}
    </Segment>
  );
};
